import { Pipe, PipeTransform } from "@angular/core";
import { filesize } from "../support/filesize";
import { isUndefined } from "lodash";

@Pipe({
  name: "fileSize",
  standalone: false
})
export class FileSizePipe implements PipeTransform {
  transform(value: number | undefined): string {
    return isUndefined(value)
      ? ""
      : filesize(value, {
          round: 0
        });
  }
}
